import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { adminLogin, getAdminToken } from "../../api/serviceDeskApi";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (getAdminToken()) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await adminLogin(username, password);
      setLoading(false);
      navigate("/admin", { replace: true });
    } catch (err) {
      setLoading(false);
      setError(err?.message || "Invalid username or password.");
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-glow admin-login-glow--orange" aria-hidden="true" />
      <div className="admin-login-glow admin-login-glow--green" aria-hidden="true" />
      <div className="admin-login-card">
        <div className="admin-login-left">
          <h1>Admin Console</h1>
          <p>Manage blogs, careers, applications, and service desk from one place.</p>
          <ul>
            <li><i className="bi bi-check-circle-fill" /> Blog &amp; category management</li>
            <li><i className="bi bi-check-circle-fill" /> Job posting &amp; applications</li>
            <li><i className="bi bi-check-circle-fill" /> Service desk tickets</li>
          </ul>
        </div>
        <form className="admin-login-form" onSubmit={handleSubmit}>
          <span className="admin-login-badge">Secure Login</span>
          <h2>Welcome back</h2>
          <p className="admin-login-hint">Sign in with your admin credentials.</p>
          {error ? <div className="admin-alert admin-alert--error">{error}</div> : null}
          <label>
            Username
            <input
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Username"
            />
          </label>
          <label>
            Password
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </label>
          <button type="submit" className="admin-btn admin-btn-primary" disabled={loading}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
